import React, { useContext, useEffect, useState } from "react";
import Input from "../controls/Input";
import Modal from "react-modal";
import icons from "react-icons/io"
import DropDown from "../controls/DropDown";
import { DataContext } from '../../data/DataContext';
import { tipoDocumentos } from '../../data/MochaData';
import http from '../../../../services/http';
import { endPoints, emailRegex } from '../../../../utils/constanst';


const Step3 = () => {

    const { SOA, setSOA, changeHandler } = useContext(DataContext);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [loading, setLoading] = useState(false);


    const clearData = () => (
        setSOA({
            ...SOA
            , nombres: '', apellidos: ''
            , telefonoCasa: '', telefonoPersonal: ''
            , correoElectronico: '', direccionDomicilio: '', mensaje: '', departamento: 0, cuidad: 0
        }));

    const load = (data) => { setSOA({ ...SOA, cargando: data })};
    
    const onClickSearch = () => {
        clearData();
        setLoading(true);
        http(endPoints.ente(SOA.numeroIdentificacion, SOA.tipoIdentidad))
            .get()
            .then((res) => {
        
                cuidadLoad(res.departamento);
                
                setSOA({
                    ...SOA
                    , nombres: res.nombre, apellidos: res.apellido
                    , telefonoCasa: res.telefonoCasa, telefonoPersonal: res.telefonoCelular
                    , correoElectronico: res.email, direccionDomicilio: res.direccion, departamento: res.departamento, cuidad: res.municipio
                    ,cargando:false 
                });

            })
            .catch((error) => {
                setSOA({ ...SOA, mensaje: 'No se encontro registro',cargando:false });
                handleShow();
            }).finally( () => {  setLoading(false) }); ;
           
    };

    const changeTypeDoc = (event) => {
        //clearData();
        setSOA({
            ...SOA, [event.target.name]: event.target.value, nombres: '', apellidos: ''
            , telefonoCasa: '', telefonoPersonal: ''
            , correoElectronico: '', direccionDomicilio: '', departamento: 0, cuidad: 0
        });
    }


    const departamentoHandler = (event) => {
       
        setSOA({ ...SOA, [event.target.name]: event.target.value });
        http(endPoints.country("505", event.target.value)).get()
            .then(data => { SOA.setCatalogos({ cuidades: data }); })
    }

    const cuidadLoad = (dep) => {
        http(endPoints.country("505", dep)).get()
            .then(data => { SOA.setCatalogos({ cuidades: data }); });
    }



    return (<div className="step">
        <div className="step-container-soa">
            <div className="mt-15">
                <span className="title2">
                    Detalles personales
        </span>
            </div>
            <div className="mt-15 mb-30">
                <span className="title3">
                    ¡Queremos conocerte! Ingresá los siguientes datos, según el documento de identidad del dueño en circulación del vehículo
        </span>
            </div>
            <DropDown isrequired={true} label="Tipo de identificación" dataProvider={tipoDocumentos} valueSelect={SOA.tipoIdentidad} fieldSelect="tipoIdentidad" field="tipoIdentidad" isrequired={true} onChangeSelect={changeTypeDoc} />

            {SOA.tipoIdentidad === "1" &&
                <Input type="mask" label="Número de identificación" value={SOA.numeroIdentificacion} field="numeroIdentificacion" onChange={changeHandler}
                    useiconSearch={true} onClickIconSearch={onClickSearch} onChange={changeHandler}
                    mask="999-999999-9999a"
                    pattern="\d\d\d-\d\d\d\d\d\d-\d\d\d\d\w"
                    title="Documento invalido"
                ></Input>
            }
            {SOA.tipoIdentidad !== "1" &&
                <Input label="Número de identificación" value={SOA.numeroIdentificacion} field="numeroIdentificacion" onChange={changeHandler}
                    useiconSearch={true} onClickIconSearch={onClickSearch} onChange={changeHandler}
                ></Input>
            }
            <Input label="Nombres" value={SOA.nombres} field="nombres" onChange={changeHandler} ></Input>
            <Input label="Apellidos" value={SOA.apellidos} field="apellidos" onChange={changeHandler}  ></Input>
            <div className="col">
                <Input label="Teléfono de casa"
                    pattern='\d\d\d\d-\d\d\d\d'
                    title='Teléfono inválido'
                    type='mask'
                    mask='9999-9999'
                    placeholder="2222-2222"
                    classNameInput="input-field-col"
                    value={SOA.telefonoCasa}
                    field="telefonoCasa"
                    onChange={changeHandler} ></Input>
                <Input label="Celular personal"
                    pattern='\d\d\d\d-\d\d\d\d'
                    title='Teléfono inválido'
                    type='mask'
                    mask='9999-9999'
                    placeholder="8888-8888" value={SOA.telefonoPersonal} field="telefonoPersonal" onChange={changeHandler}  ></Input>
            </div>
            <Input label="Correo electrónico" placeholder="ejemplo@ejemplo.com" value={SOA.correoElectronico} field="correoElectronico" onChange={changeHandler}

            ></Input>
            <DropDown isrequired={true} containBlank={true} label="Departamento" dataProvider={SOA.catalogos.departamentos} valueSelect={SOA.departamento} fieldSelect="departamento" field="departamento" isrequired={true} onChangeSelect={departamentoHandler} />
            <DropDown isrequired={true} containBlank={false} label="Cuidad" dataProvider={SOA.catalogos.cuidades} valueSelect={SOA.cuidad} fieldSelect="cuidad" field="cuidad" isrequired={true} onChangeSelect={changeHandler} />
            <Input label="Dirección de domicilio" type="textarea" value={SOA.direccionDomicilio} field="direccionDomicilio" onChange={changeHandler} classNameInput="input-field-area" ></Input>

        </div>
        <Modal className="modal" isOpen={show} show={show} ariaHideApp={false}>
            <div className="modal-title">
                <span className="txt-title-modal">Información</span>
            </div>
            <div className="modal-body-info">
                {SOA.mensaje}
            </div>
            <div className="modal-footer">
                <button type="button" className="modal-btn-close" onClick={handleClose}>Cerrar</button>
            </div>
        </Modal>
        <Modal className="modal" isOpen={loading} show={loading} ariaHideApp={false}>
                <div className="dialog-center-content">
                    <p className="text-center">Cargando...</p>
                </div>
            </Modal>
    </div>);
}

export default Step3;